import styled from 'styled-components';

export const EstatisticaContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 15px;
`;
